<mat-table [dataSource]="filteredData" matSort aria-label="Meeting Occurance List">
  <!-- column definitions -->
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns; index as i">
    <mat-header-cell
      mat-sort-header
      *matHeaderCellDef
      [disabled]="!columnConfig[i].sort"
      [class.is-small-column]="columnConfig[i].key === 'parentMeetingOccurrenceKey'"
    >
      <ng-container>
        {{ columnConfig[i].label }}
      </ng-container>
    </mat-header-cell>

    <mat-cell
      *matCellDef="let cell; index as j"
      [class.is-linkable]="columnConfig[i].linkable"
      [class.is-small-column]="columnConfig[i].key === 'parentMeetingOccurrenceKey'"
    >
      <ng-container *ngIf="columnConfig[i].key === 'parentMeetingOccurrenceKey'">
        <a
          href="javascript: void(0);"
          (click)="viewAppointment(cell.parentMeetingOccurrenceKey, cell.parentMeetingKey)"
        >
          {{ cell.parentMeetingOccurrenceKey }}
        </a>
      </ng-container>

      <ng-container
        *ngIf="columnConfig[i].key === 'startISOFormatted' || columnConfig[i].key === 'endISOFormatted'"
      >
        {{ cell[column] }}
      </ng-container>

      <ng-container *ngIf="columnConfig[i].key === 'clientName'">
        <a href="javascript: void(0);" (click)="viewClient(cell.parentClientKey, cell.parentCaseKey)">
          {{ cell.clientName }}
        </a>
      </ng-container>

      <ng-container
        *ngIf="
          columnConfig[i].key !== 'startISOFormatted' &&
          columnConfig[i].key !== 'endISOFormatted' &&
          columnConfig[i].key !== 'parentMeetingOccurrenceKey' &&
          columnConfig[i].key !== 'clientName'
        "
      >
        {{ cell[column] }}
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- Header Row-->
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>

  <!-- Select Record -->
  <mat-row *matRowDef="let cell; columns: columns"></mat-row>
</mat-table>

<!-- No data found -->
<ng-container *transloco="let t;">
  <ng-container *ngIf="isReady && filteredData.length < 1">
    <div class="noresult">
      <div class="center">{{t('NoResultsFound')}}.</div>
    </div>
  </ng-container>
</ng-container>